import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
      },
    clientname: {
      validations: []
      },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' }, ,
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
          },
    cellNumber: {
      validations: []
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
      },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
          },
    salesRep: {
      validations: []
       },
    theme: {
      validations: []
    },
    plannedguestcount: {
      validations: []
      },
    StartTime: {
      validations: []
    },
    sitename: {
      validations: []
    },
    siteaddress: {
      validations: []
    },
    sitecity: {
      validations: []
    },
    sitestate: {
      validations: []
    },
    sitepostal: {
      validations: []
      },
    operation: {
      validations: []
      },
    category: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Your Contact Information',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
       {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company Name:',
            mapping: 'clientname',
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number:*',
            mapping: 'telNumber'
    }  
        ]
      },
      {
        fields: [
          {
           type: 'text',
           size: 'Medium',
           label: 'Cell Phone:',
           mapping: 'cellNumber'
         }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
           }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Your Event Details',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:',
            mapping: 'eventDate'
          }
        ]
      },
       {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Who are you working with?',
            options: [
              { label: 'Amy'  , value: 'Amy'},
              { label: 'Sandy'  , value: 'Sandy'},
              { label: 'Michael/Food Truck'  , value: 'Michael/Food Truck'},
              { label: 'First Time Ordering'  , value: 'First Time Ordering'},
            ],
            mapping: 'salesRep'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Event:',
            options: [
              { label: 'Baby Q Shower'  , value: 'Baby Q Shower'},
              { label: 'Bachelor Party'  , value: 'Bachelor Party'},
              { label: 'Bachelorette Party'  , value: 'Bachelorette Party'},
              { label: 'Baptism'  , value: 'Baptism'},
              { label: 'BBQ Luncheon'  , value: 'BBQ Luncheon'},
              { label: 'BBQ Party'  , value: 'BBQ Party'},
              { label: 'Birthday Party'  , value: 'Birthday Party'},
              { label: 'Bridal Shower'  , value: 'Bridal Shower'},
              { label: 'Celebration of Life'  , value: 'Celebration of Life'},
              { label: 'Church Function'  , value: 'Church Function'},
              { label: 'Company Pinic'  , value: 'Company Pinic'},
              { label: 'Construction Crew'  , value: 'Construction Crew'},
              { label: 'Corporate Event'  , value: 'Corporate Event'},
              { label: 'Employee Appreciation Luncheon'  , value: 'Employee Appreciation Luncheon'},
              { label: 'Family Reunion'  , value: 'Family Reunion'},
              { label: 'Graduation Party'  , value: 'Graduation Party'},
              { label: 'Holiday Employee Appreciation'  , value: 'Holiday Employee Appreciation'},
              { label: 'Holiday Meal'  , value: 'Holiday Meal'},
              { label: 'Holiday Party'  , value: 'Holiday Party'},
              { label: 'Meeting'  , value: 'Meeting'},
              { label: 'Office Party'  , value: 'Office Party'},
              { label: 'PTO'  , value: 'PTO'},
              { label: 'Rehearsal Dinner'  , value: 'Rehearsal Dinner'},
              { label: 'Retirement Party'  , value: 'Retirement Party'},
              { label: 'School'  , value: 'School'},
              { label: 'Sports Team'  , value: 'Sports Team'},
              { label: 'Wedding Reception'  , value: 'Wedding Reception'},
            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests:',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Time of Meal Service:',
            options: [
              { label: '10:30 AM', value: '10:30:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '11:30 AM', value: '11:30:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '12:30 PM', value: '12:30:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '1:30 PM', value: '13:30:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '2:30 PM', value: '14:30:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '3:30 PM', value: '15:30:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '4:30 PM', value: '16:30:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '5:30 PM', value: '17:30:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '6:30 PM', value: '18:30:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '7:30 PM', value: '19:30:00' },
              { label: '8:00 PM', value: '20:00:00' },
              { label: '8:30 PM', value: '20:30:00' },
              { label: '9:00 PM', value: '21:00:00' },
              { label: '9:30 PM', value: '21:30:00' },
              { label: '10:00 PM', value: '22:00:00' },
            ],
            mapping: 'StartTime'
          }
        ]
      },
       {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Venue/Location Name:',
            mapping: 'sitename'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Venue/Location Address:',
            mapping: 'siteaddress'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Venue/Location City:',
            mapping: 'sitecity'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Venue/Location State:',
            options: [
              { label: 'MN', value: 'MN' },
              { label: 'WI', value: 'WI' },
            ],
            mapping: 'sitestate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Venue/Location Zip Code:',
            mapping: 'sitepostal'
          }
        ]
      },
       {
      fields: [
        {
          type: 'multiple-choice',
          size: 'Medium',
          label: 'Nearest Location:',
          options: [
            { label: 'Hudson #103', value: 'Hudson #103' },
            { label: 'Minneapolis #104', value: 'Minneapolis #104' },
            { label: 'Arden Hills #105', value: 'Arden Hills #105' },
            { label: 'Shakopee #106', value: 'Shakopee #106' },
            { label: 'Excelsior #107', value: 'Excelsior #107' },
          ],
          mapping: 'operation'
        }
      ]
    },
     {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Service Style:',
            options: [
            { label: 'Pickup'  , value: 'Pickup'},
            { label: 'Delivery & Setup'  , value: 'Delivery & Setup'},
            { label: 'Jimmie\'s Full Service'  , value: 'Jimmie\'s Full Service'},
            { label: 'Rustic Chic Full Service'  , value: 'Rustic Chic Full Service'},
            { label: 'Food Truck "Full Rack"'  , value: 'Food Truck "Full Rack"'},
            { label: 'Vending "Full Rack"'  , value: 'Vending "Full Rack"'},
            ],
            mapping: 'category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Is there any additional information you would like to add?:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SEND'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Jimmie\'s Old Southern BBQ Contact Us Form',
    formId: '2263',
    clientKey: '8D3C235B-3FAA-4FA3-B157-5A32A105C3A1',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
